import { render } from "./modal-create-task.vue?vue&type=template&id=8d9f7ab0&scoped=true"
import script from "./modal-create-task.vue?vue&type=script&lang=js"
export * from "./modal-create-task.vue?vue&type=script&lang=js"

import "./modal-create-task.vue?vue&type=style&index=0&id=8d9f7ab0&lang=sass&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d9f7ab0"]])

export default __exports__